import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';
import { Botadmin } from './../models/botadmin';
import 'rxjs/add/operator/map';


@Injectable({
  providedIn: 'root'
})
export class BotadmonService {

  constructor(
    public http: HttpClient
  ) { }


  statusbotAdmin( botadmin: Botadmin, id: string ) {
    let url = URL_SERVICIOS + '/botadmin/' + id;
   // console.log ('==============', url)
    return this.http.put ( url , botadmin);
    // .map (( resp: any ) => {
    //  alert ('Your information has been received.  You will be notified by email once you are authorized');
    // });

  }



  getstatusBotAdmin(){
    let url = URL_SERVICIOS + '/botadmin/61da8045325f1a6a889eed07';
    return this.http.get (url);
    



    
  }




}
